export const GET_BANK_LIST_REQUEST = 'GET_BANK_LIST_REQUEST';
export const GET_BANK_LIST_SUCCESS = 'GET_BANK_LIST_SUCCESS';
export const GET_BANK_LIST_FALI = 'GET_BANK_LIST_FALI';
